


const formatNumber = (number, n = 0, x = 3, s = '.', c = ',') => {
    if(!number) number = 0;
    var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
        num = number.toFixed(Math.max(0, ~~n));

    return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
};




module.exports = {
    formatNumber
}


// WEBPACK FOOTER //
// ./src/util/formatters.js